import request from '@/utils/request'

// 查询用户相关审核记录列表
export function listRelatedAuditRecord(query) {
  return request({
    url: '/user/related/audit/record/list',
    method: 'get',
    params: query
  })
}

// 查询用户相关审核记录详细
export function getRelatedAuditRecord(id) {
  return request({
    url: '/user/related/audit/record/' + id,
    method: 'get'
  })
}

// 新增用户相关审核记录
export function addRelatedAuditRecord(data) {
  return request({
    url: '/user/related/audit/record',
    method: 'post',
    data: data
  })
}

// 修改用户相关审核记录
export function updateRelatedAuditRecord(data) {
  return request({
    url: '/user/related/audit/record',
    method: 'put',
    data: data
  })
}

// 删除用户相关审核记录
export function delRelatedAuditRecord(id) {
  return request({
    url: '/user/related/audit/record/' + id,
    method: 'delete'
  })
}
